import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  return <nav className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="flex justify-between h-16" data-id="element-256">
          <div className="flex items-center" data-id="element-257">
            <div className="flex-shrink-0" data-id="element-258">
              <Link to="/" className="text-2xl font-extrabold tracking-tight text-primary" data-id="element-259">
                steward
              </Link>
            </div>
          </div>
          <div className="hidden sm:flex sm:items-center sm:space-x-8" data-id="element-260">
            <Link to="/platform" className="text-customgray hover:text-primary inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors" data-id="element-261">
              Platform
            </Link>
            <Link to="/solutions" className="text-customgray hover:text-primary inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors" data-id="element-262">
              Solutions
            </Link>
            <Link to="/resources" className="text-customgray hover:text-primary inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors" data-id="element-263">
              Resources
            </Link>
            <Link to="/pricing" className="text-customgray hover:text-primary inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors" data-id="element-264">
              Pricing
            </Link>

            <div className="flex items-center space-x-4 ml-4 pl-4 border-l border-gray-200" data-id="element-265">
              <button className="text-sm font-medium text-customgray hover:text-primary transition-colors" data-id="element-266">
                Log in
              </button>
              <button onClick={() => navigate('/demo')} className="bg-accent hover:bg-cyan-400 text-white font-medium py-2 px-4 rounded-lg shadow-sm transition duration-150 ease-in-out" data-id="element-267">
                Book a Demo
              </button>
            </div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden" data-id="element-268">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent" data-id="element-269">
              <span className="sr-only" data-id="element-270">Open main menu</span>
              {isMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-271" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-272" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && <div className="sm:hidden bg-white border-b border-gray-200 shadow-lg absolute w-full" data-id="element-273">
          <div className="pt-2 pb-3 space-y-1" data-id="element-274">
            <Link to="/platform" onClick={() => setIsMenuOpen(false)} className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-accent hover:text-primary" data-id="element-275">
              Platform
            </Link>
            <Link to="/solutions" onClick={() => setIsMenuOpen(false)} className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-accent hover:text-primary" data-id="element-276">
              Solutions
            </Link>
            <Link to="/resources" onClick={() => setIsMenuOpen(false)} className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-accent hover:text-primary" data-id="element-277">
              Resources
            </Link>
            <Link to="/pricing" onClick={() => setIsMenuOpen(false)} className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:bg-gray-50 hover:border-accent hover:text-primary" data-id="element-278">
              Pricing
            </Link>
            <div className="mt-4 pt-4 border-t border-gray-100 px-4 flex flex-col space-y-3 pb-4" data-id="element-279">
              <button className="w-full text-center text-base font-medium text-customgray hover:text-primary" data-id="element-280">
                Log in
              </button>
              <button onClick={() => navigate('/demo')} className="w-full bg-accent hover:bg-cyan-400 text-white font-medium py-2 px-4 rounded-lg shadow-sm transition duration-150 ease-in-out" data-id="element-281">
                Book a Demo
              </button>
            </div>
          </div>
        </div>}
    </nav>;
};
export default Navbar;